export default __webpack_public_path__ + "static/RUBICON-L-SERIES-30-DISK-SCRUBBER-772d50a3277fd1c9d3b42e3398ebc568.png";